
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "VConstructor"
})
export default class VConstructor extends Vue {}
